import React, { useEffect, useState } from "react";
import { awaitedClip, publishClipState, subscribeAwaited } from "utils/clipRegistry";
import { BadgeSC, SkipButtonSC } from "./styled";

/**
 * Say why the lecture has stopped, and offer a way out of it.
 *
 * The wait is unbounded on purpose: how long a voicing takes to become playable is a property of
 * the machine, and the previous eight-second ceiling — after which the lecture went on without the
 * clip — is precisely the "it doesn't wait, it just skips" that was reported. But an unbounded wait
 * that says nothing is indistinguishable from a frozen editor, and a genuinely broken file would
 * trap the translator. So the wait is always named, always timed, and always escapable.
 */

/** Before this, a pause reads as normal preparation and needs no explaining away. */
const OFFER_SKIP_AFTER_MS = 4000;

export const WaitingBadge: React.FC = () => {
    const [awaited, setAwaited] = useState<string | null>(() => awaitedClip());
    const [elapsedMs, setElapsedMs] = useState(0);

    useEffect(() => subscribeAwaited(setAwaited), []);

    useEffect(() => {
        if (!awaited) {
            setElapsedMs(0);
            return;
        }
        const since = Date.now();
        setElapsedMs(0);
        const timer = window.setInterval(() => setElapsedMs(Date.now() - since), 200);
        return () => window.clearInterval(timer);
    }, [awaited]);

    if (!awaited) return null;

    return (
        <BadgeSC>
            <span>Ожидание озвучки… {(elapsedMs / 1000).toFixed(1).replace(".", ",")} с</span>
            {elapsedMs >= OFFER_SKIP_AFTER_MS && (
                <SkipButtonSC
                    type="button"
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={() =>
                        // Marking it broken is what lets the schedule pass it over: it is the same
                        // state a missing file gets, and it is what "go on without it" means.
                        publishClipState(awaited, "error", "пропущена вручную")
                    }
                >
                    продолжить без озвучки
                </SkipButtonSC>
            )}
        </BadgeSC>
    );
};
